import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QualificationV2SelectComponent } from '@wilson/qualification-v2/common';
import { BaseFilterDirective } from '../../base-filter.directive';
import { FilterService } from '../../filter.service';
import { MultiSelectParserService } from '../../services/multi-select-parser.service';

@Component({
  selector: 'wilson-qualification-v2-filter',
  templateUrl: './qualification-v2-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, QualificationV2SelectComponent],
})
export class QualificationV2FilterComponent extends BaseFilterDirective<
  string[]
> {
  protected readonly filterService = inject(FilterService);
  protected readonly parserService = inject(MultiSelectParserService);

  constructor() {
    super('qualificationV2');
  }
}
